import React, { FC, useContext, useCallback, MouseEvent } from 'react';

import Button from 'vibo-ui/Button';
import WithEventRole from 'components/user/WithEventRole';
import { EventContext } from 'components/context/EventContext';
import { TimelineQuestionsContext } from 'components/events/Timeline/TimelineQuestionsBlock/TimelineQuestionsContext';

import { useModal } from 'vibo-ui/Modal';

import { EventUserType, Modals } from 'types/enums';
import { AddTimelineSectionButtonProps } from './interfaces';
import { useTimeline } from 'components/events/Timeline/TimelineContext';
import { CreateQuestionModalProps } from 'components/modals/CreateQuestionModal';

const AddTimelineQuestionButton: FC<AddTimelineSectionButtonProps> = ({
  questionIdAfter,
  children,
  ...rest
}) => {
  const eventContext = useContext(EventContext);
  const timelineQuestionsContext = useContext(TimelineQuestionsContext);
  const timelineContext = useTimeline();

  const { openModal } = useModal();

  const openCreateQuestionModal = useCallback(
    () =>
      openModal<CreateQuestionModalProps>({
        key: Modals.createQuestion,
        props: {
          timelineContext,
          timelineQuestionsContext,
          questionIdAfter,
          eventContext,
        },
      }),
    [timelineQuestionsContext, questionIdAfter, eventContext]
  );

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    openCreateQuestionModal();
  };

  return (
    <WithEventRole roles={[EventUserType.dj]} extraCondition={eventContext.canEdit}>
      <Button onClick={handleClick} {...rest}>
        {children}
      </Button>
    </WithEventRole>
  );
};

export default AddTimelineQuestionButton;
